import { Option } from '@lib/interfaces/form';
import { TabsType } from '../enums';

export default function getFilteredOptions(
  opts: Option[],
  search: string,
  tabType: TabsType,
  selected: Option[],
) {
  let filtered = search.length
    ? opts.filter(
        ({ value: optionValue }) =>
          typeof optionValue === 'string' &&
          optionValue &&
          optionValue.toLowerCase().indexOf(search.toLowerCase()) > -1,
      )
    : opts;
  if (tabType === TabsType.Selected) {
    filtered = filtered.filter((option) =>
      selected.some((selectedOption) => selectedOption.id === option.id),
    );
  }
  return filtered;
}
